var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserManual = function SvgUserManual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10155",
    transform: "translate(-691 -626.335)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#ebebeb",
    "data-name": "Ellipse 760",
    transform: "translate(691 626.335)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4629",
    transform: "translate(736.437 671.772)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.282,
    cy: 9.282,
    r: 9.282,
    fill: "#ffc62d",
    "data-name": "Ellipse 686"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.729 3.276h13.1v13.1h-13.1Z",
    "data-name": "Path 4503"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.103 8.19h-2.184V4.914H7.643V8.19H5.459l3.822 3.824ZM8.735 9.282V6.006h1.092v3.276h.639l-1.185 1.185-1.185-1.185Zm-3.276 3.822h7.644v1.092H5.459Z",
    "data-name": "Path 4504"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3890"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M705.5 640.702h35v35h-35z",
    "data-name": "Rectangle 4463"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3893"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0e2240",
    "data-name": "Group 3892"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M735.921 648.75a17.7 17.7 0 0 0-5.078-.7c-2.829 0-5.876.562-7.98 2.106-2.103-1.544-5.15-2.106-7.979-2.106s-5.88.562-7.98 2.106v20.57a.77.77 0 0 0 .725.7c.145 0 .218-.07.363-.07a18.2 18.2 0 0 1 6.892-1.543c2.829 0 5.876.562 7.98 2.106a17.9 17.9 0 0 1 7.98-2.106 15.2 15.2 0 0 1 6.892 1.474.67.67 0 0 0 .363.07.77.77 0 0 0 .725-.7v-20.501a10 10 0 0 0-2.903-1.406m0 18.955a17.4 17.4 0 0 0-5.078-.7 17.9 17.9 0 0 0-7.98 2.106v-16.147a17.9 17.9 0 0 1 7.98-2.106 17.4 17.4 0 0 1 5.078.7Z",
    "data-name": "Path 4535"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3891"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M731.1 656.474a16.4 16.4 0 0 1 3.51.365v-2.134a19 19 0 0 0-3.51-.337 16.2 16.2 0 0 0-6.318 1.165v2.335a13.04 13.04 0 0 1 6.318-1.394",
    "data-name": "Path 4536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.782 659.268v2.331a13.04 13.04 0 0 1 6.318-1.39 16.4 16.4 0 0 1 3.51.365v-2.131a19 19 0 0 0-3.51-.337 16.4 16.4 0 0 0-6.318 1.162",
    "data-name": "Path 4537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.1 661.852a16.2 16.2 0 0 0-6.318 1.17v2.331a13.04 13.04 0 0 1 6.318-1.39 16.4 16.4 0 0 1 3.51.365v-2.139a18 18 0 0 0-3.51-.337",
    "data-name": "Path 4538"
  })))))));
};
export { SvgUserManual as ReactComponent };
export default "/_next/static/images/userManual.svg";